import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentService } from '../environment.service';
import { AuthService } from '../auth.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RolesAndPermissionService {
  apiBaseURL!: string;
  constructor(
    private readonly http: HttpClient,
    environmentService: EnvironmentService,
    private readonly auth: AuthService
  ) {
    this.apiBaseURL = environmentService.getApiEndpoint();
  }

  createRolesAndPermission(formData: any): Observable<any> {
    return this.http.post<any>(this.apiBaseURL + 'rolepermission', formData);
  }

  getRolesAndPermission(id: any): Observable<any> {
    return this.http.get<any>(this.apiBaseURL + 'rolepermission/' + id);
  }

  updateRolesAndPermission(formData: any): Observable<any> {
    return this.http.put<any>(this.apiBaseURL + 'rolepermission/1', formData);
  }

  getUserGroup(params = {}): Observable<any> {
    let options = {
      params: new HttpParams({ fromObject: params })
    }
    return this.http.get<any>(this.apiBaseURL + 'usergroup', options);
  }

  getGroupBasePermission(
    id: string,
    clientid: string,
    companyid: string,
    search: string
  ): Observable<any> {
    return this.http.get<any>(
      this.apiBaseURL +
      'rolepermission/group/' +
      id +
      `?clientid=${clientid}&companyid=${companyid}&search=${search}`
    );
  }

  getGroupBasePermissionSearch(
    id: string,
    clientid: string,
    companyid: string,
    search: string
  ): Observable<any> {
    return this.http.get<any>(
      this.apiBaseURL +
      'rolepermission/search/' +
      id +
      `?clientid=${clientid}&companyid=${companyid}&search=${search}`
    );
  }

  getPermission(id: string): Observable<any> {
    return this.http.get<any>(
      this.apiBaseURL + 'rolepermission/permission/' + id
    );
  }
}
